import {useState} from 'react';
import {
  Button,
  Input,
  Text,
  VStack,
  HStack,
  useColorModeValue,
  Box,
} from '@chakra-ui/react';
import ModalFrame from './common/ModalFrame';

export function PasswordModal({
  isOpen,
  onClose,
  onSubmit,
  email,
  error,
}: Record<string, any>) {
  const [password, setPassword] = useState('');

  const handleSubmit = (e: any) => {
    e.preventDefault();
    onSubmit(password);
    setPassword('');
  };

  const bgColor = useColorModeValue('white', 'gray.800');
  const textColor = useColorModeValue('gray.600', 'gray.300');
  const emailColor = useColorModeValue('gray.800', 'white');
  const errorBg = useColorModeValue('gray.50', 'rgba(194, 194, 194, 0.1)');
  const errorText = useColorModeValue('gray.500', 'gray.200');

  return (
    <ModalFrame
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      title="Link Microsoft Account"
      overlayProps={{bg: 'blackAlpha.300', backdropFilter: 'blur(10px)'}}
      contentProps={{bg: bgColor, mx: 4}}
      bodyProps={{pb: 6}}
    >
      <Text color={textColor} mb={6}>
        An account with email{' '}
        <Text as="span" fontWeight="normal" color={emailColor}>
          {email}
        </Text>{' '}
        already exists. Please enter your password to link your Microsoft
        account.
      </Text>
      {error && (
        <Box mb={4} p={3} bg={errorBg} borderRadius="md">
          <Text color={errorText} fontSize="sm">
            {error}
          </Text>
        </Box>
      )}
      <form onSubmit={handleSubmit}>
        <VStack spacing={6}>
          <Input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            placeholder="Enter your password"
            size="lg"
            required
          />
          <HStack spacing={3} w="full" justify="flex-end">
            <Button variant="ghost" onClick={onClose} colorScheme="gray">
              Cancel
            </Button>
            <Button type="submit" colorScheme="gray" size="md">
              Link Account
            </Button>
          </HStack>
        </VStack>
      </form>
    </ModalFrame>
  );
}
